import apiV2ErrorTranslations from 'ha/constants/apiV2ErrorTranslations';

import { TranslateFunc } from 'ha/i18n';
import { ResponseError } from 'ha/services/apiV2/types/ResponseError';

export class SubmissionError extends Error {
  static __FLAG__ = '@@redux-form/submission-error-flag';

  errors: Record<string, string>;

  constructor(errors: Record<string, string>) {
    super('Submit Validation Failed');
    this.errors = errors;
  }
}

const translationKeyOrDefault = (message: string): string =>
  apiV2ErrorTranslations[message] || message;


export function normalizeApiV2Errors(
  T: TranslateFunc,
  err: ResponseError,
): SubmissionError {
  const apiErrors =
    (err && err.cause && err.cause.response && err.cause.response.errors) ||
    null;

  if (!apiErrors) {
    return new SubmissionError({
      _error: T(translationKeyOrDefault(err.message)),
    });
  }

  const errors = apiErrors.reduce((acc, error) => {
    if (!error.key) {
      // eslint-disable-next-line no-underscore-dangle
      acc._error = T(translationKeyOrDefault(error.detail));
    } else {
      acc[error.key] = T(translationKeyOrDefault(error.detail));
    }

    return acc;
  }, {} as Record<string, string>);

  return new SubmissionError(errors);
}
